export default "__VITE_ASSET__fb779b60__"